export default {

  // HML credentials
  // serverURI: 'https://mundomaker-api.flowcap.net/',
  // imageServerURI: 'https://mundomaker-api.flowcap.net/media/',
  // appServerURI: 'https://mundomaker-api.flowcap.net/',

  // firebaseconfig: {
  //   apiKey: 'AIzaSyATSdXb8KB40APZBEFpVskTe9cJPdfVfHY',
  //   authDomain: 'mundomaker-homologacao.firebaseapp.com',
  //   storageBucket: 'mundomaker-homologacao.appspot.com'
  // },

  // production
  serverURI: 'https://app-api.mundomaker.cc/',
  imageServerURI: 'https://app-api.mundomaker.cc/media/',
  appServerURI: 'https://app-api.mundomaker.cc/',

  firebaseconfig: { // MundoMaker
    apiKey: 'AIzaSyAVkKpPagD6nH3NR-CFiBFyAUhoGJ-EFlo',
    authDomain: 'mundomaker-prod.firebaseapp.com',
    storageBucket: 'mundomaker-prod.appspot.com'
  },

  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js